import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import { Assessment } from '@mui/icons-material';

const MCRReports = () => {
  return (
    <Box sx={{ flexGrow: 1, p: 3, width: '100%' }}>
      <Container maxWidth={false} disableGutters>
        <Paper 
          elevation={0}
          sx={{ 
            p: 5, 
            textAlign: 'center',
            bgcolor: 'background.default',
            border: '2px dashed',
            borderColor: 'divider',
            borderRadius: 2
          }}
        >
          <Assessment sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h4" color="text.primary" gutterBottom>
            MCR Reports
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Comprehensive reporting features coming soon...
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default MCRReports;
